import { gql } from '@apollo/client'
import { DELIVERY_ZONE_FIELDS } from './delivery-queries'

// All four require delivery.manage.

// Global on/off. Returns the fresh DeliverySettings, so the full settings shape
// is selected here — one round trip is enough to re-render the whole screen.
export const SET_DELIVERY_ENABLED = gql`
  ${DELIVERY_ZONE_FIELDS}
  mutation SetDeliveryEnabled($enabled: Boolean!) {
    setDeliveryEnabled(enabled: $enabled) {
      enabled
      zones {
        ...DeliveryZoneFields
      }
    }
  }
`

export const CREATE_DELIVERY_ZONE = gql`
  ${DELIVERY_ZONE_FIELDS}
  mutation CreateDeliveryZone($input: CreateDeliveryZoneInput!) {
    createDeliveryZone(input: $input) {
      ...DeliveryZoneFields
    }
  }
`

// PARTIAL update — send only the fields being changed; omitted fields keep
// their stored value. `postcode` is updatable too.
export const UPDATE_DELIVERY_ZONE = gql`
  ${DELIVERY_ZONE_FIELDS}
  mutation UpdateDeliveryZone($id: Int!, $input: UpdateDeliveryZoneInput!) {
    updateDeliveryZone(id: $id, input: $input) {
      ...DeliveryZoneFields
    }
  }
`

// HARD delete — the row and its prices are gone. Existing orders keep the fee
// they were created with, so this is safe server-side, but confirm it first.
export const DELETE_DELIVERY_ZONE = gql`
  mutation DeleteDeliveryZone($id: Int!) {
    deleteDeliveryZone(id: $id)
  }
`
